document.addEventListener("DOMContentLoaded", () => {

  const intro = document.getElementById("pyr-intro");

  if (!intro) return;

  if (sessionStorage.getItem("pyr_intro_seen")) {
    intro.remove();
    return;
  }

  const video = intro.querySelector("video");
  const skipBtn = document.getElementById("pyr-skip");

  document.body.style.overflow = "hidden";

  function closeIntro() {

    sessionStorage.setItem("pyr_intro_seen", "true");

    document.body.style.overflow = "";

    intro.classList.add("hide");

    setTimeout(() => {
      intro.remove();
    }, 800);

  }

  skipBtn.addEventListener("click", closeIntro);

  video.addEventListener("ended", closeIntro);

  video.play().catch(() => {});

});